import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdvancePaymentModel } from './advancePayment.model';
import { AdvancePaymentService } from './advancePayment.service';
import { AccountsAndTaxesModel } from '../../invoice/preinvoice/accountsandtaxes.model';
import { PreinvoiceService } from '../../invoice/preinvoice/preinvoice.service';
import { AdvancedPaymentLineModel } from './advancedPaymentline.model';
import { ConceptService } from '../../concept/concept/concept.service';
import { ConceptModel } from '../../concept/concept/concept.model';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { PaymentCardModel } from '../../finanzas/paymentcard/paymentcard.model';
import { PaymentCardService } from '../../finanzas/paymentcard/paymentcard.service';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';

@Component({
    selector: 'convfact-advancepayment',
    templateUrl: './advancePayment.component.html',
    styleUrls: ['./advancePayment.component.css'],
    standalone: false
})
export class AdvancePaymentComponent implements OnInit {
  advancePayment = new AdvancePaymentModel();
  errors = {};
  accountsAndTaxes = new AccountsAndTaxesModel();
  ready: boolean = false;
  concepts: ConceptModel[] = [];
  bankAccounts: BankAccountModel[] = [];
  paymentCards: PaymentCardModel[] = [];

  submit(): void {}

  constructor(
    private advancePaymentService: AdvancePaymentService,
    private preinvoiceService: PreinvoiceService,
    private route: ActivatedRoute,
    private conceptService: ConceptService,
    private router: Router,
    private paymentCardService: PaymentCardService,
    private bankAccountService: BankAccountService
  ) {}

  saveData = (advancePayment): void => {
    this.ready = false;
    if (advancePayment.uid == null) {
      this.advancePaymentService.addData(advancePayment)
        .then(response => {
          this.advancePayment = response;
          this.ready = false;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    } else {
      this.advancePaymentService.editData(advancePayment.uid, advancePayment)
        .then(response => {
          this.advancePayment = response;
          this.ready = false;
          this.returnToIndex();
        })
        .catch(errors => this.errors = JSON.parse(errors['error'])['data']);
    }
  };

  ngOnInit(): void {
    this.advancePayment.advancedPaymentLines = new Array<AdvancedPaymentLineModel>();

    this.preinvoiceService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
      this.conceptService.getList().then(response => {
        this.concepts = response;
        this.ready = true;
      });
    });

    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid !== undefined) {
        this.advancePaymentService.loadData(uid).then(response => {
          this.advancePayment = response;
          this.ready = true;
        });
      }
    });

    this.bankAccountService.getList().then(bankAccounts => {
      this.bankAccounts = bankAccounts.list;

      this.paymentCardService.getList(0).then(paymentCards => {
        this.paymentCards = paymentCards.list;
        this.ready = true;
      });
    });
  }

  returnToIndex = (): void => {
    this.router.navigate(['/expense/advancepayment/provider']);
  };
}